import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Pagination from '_views/pagination';
import ActivationCodeItem from './item'

const ActivationCodeList = ({
  canNavigateUsers,
  canAdminLicenses,

  licenses,
  onDeactivateLicense,
  onUpgradeLicense,
  onTransferLicense,

  owner,
  setNavigation,
  pageNum,
  perPage,
  total,
  onGoToPage
}) => {

  const goToPage = ({ pageNum, perPage }) => onGoToPage(pageNum, perPage);

  return (
    <Fragment>
      <Pagination goToPage={ goToPage } pageNum={ pageNum } perPage={ perPage } total={ total } />
      {
        licenses.map(lic => (
          <ActivationCodeItem
            key={ lic._id }
            owner={ owner }
            setNavigation={ setNavigation }
            license={ lic }
            canAdminLicense={ canAdminLicenses }
            canNavigateUsers={ canNavigateUsers }
            onTransfer={ onTransferLicense }
            onUpgrade={ onUpgradeLicense }
            onDeactivate={ onDeactivateLicense }
          />
        ))
      }
    </Fragment>
  );
};

ActivationCodeList.propTypes = {
  licenses: PropTypes.arrayOf(PropTypes.object).isRequired,

  onGoToPage: PropTypes.func.isRequired,
  pageNum: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,

  onUpgradeLicense: PropTypes.func,
  onDeactivateLicense: PropTypes.func.isRequired,
  onTransferLicense: PropTypes.func,

  canAdminLicenses: PropTypes.bool.isRequired,
  canNavigateUsers: PropTypes.bool.isRequired,
  setNavigation: PropTypes.func.isRequired,

  owner: PropTypes.shape({
    _id: PropTypes.string.isRequired
  }).isRequired
};

export default ActivationCodeList;



// WEBPACK FOOTER //
// ./webAdmin/views/activationCodes/list.js